import View from './view';

export const ProfileUserEmailConfirmation = View;
